import React, { useMemo } from "react";
import { Dialog, DialogContent, TextField, Grid, DialogActions, Button, DialogTitle, Divider, } from "@material-ui/core";
import { SelectListField } from "../../../common/SelectListField";
import { activityDocumentTypesService } from "../../../../services";
import { useFormState } from "../../../../hooks/useFormState";
import { useDispatch } from "react-redux";
import { submitActivityDocument } from "../../../../redux/actions";
import { stageLookupMapper } from "./stageLookupMapper";
import { FileInput } from "@ofqual/portal-components/components/FileInput";
const MULTILINE_ROW_HEIGHT = 8;
export const NewDocumentDialog = ({ isDialogOpen, onDialogClose, caseId, stage, }) => {
    const dispatch = useDispatch();
    const { formProps, formPropsMultipleFileInput, triggerSubmit, triggerReset } = useFormState({}, ["note", "documentType", "file"], ({ state }) => {
        const { documentType } = state.values;
        activityDocumentTypesService.get(documentType).then(item => {
            const stageTo = item === null || item === void 0 ? void 0 : item.stageTo;
            const arg = stageTo ? Object.assign(Object.assign({}, state.values), { stageTo }) : Object.assign({}, state.values);
            dispatch(submitActivityDocument(caseId, arg));
            onDialogClose();
            triggerReset();
        });
    });
    const mappedLookupService = useMemo(() => ({
        getAll: () => activityDocumentTypesService
            .getAll()
            .then(({ data }) => ({ data: stageLookupMapper(data, stage) })),
    }), [stage]);
    return (React.createElement(Dialog, { open: isDialogOpen, onClose: () => {
            onDialogClose();
            triggerReset();
        }, maxWidth: "md", fullWidth: true },
        React.createElement(DialogTitle, null, "Attach Document"),
        React.createElement(Divider, null),
        React.createElement(DialogContent, null,
            React.createElement("form", null,
                React.createElement(Grid, { container: true, spacing: 3 },
                    React.createElement(Grid, { item: true, xs: 12, sm: 12 },
                        React.createElement(SelectListField, Object.assign({}, formProps("documentType"), { label: "Document Type", service: mappedLookupService, dataTest: "attach-document-type-list" }))),
                    React.createElement(Grid, { item: true, xs: 12, sm: 12 },
                        React.createElement(TextField, Object.assign({ variant: "outlined" }, formProps("note"), { label: "Note", "data-test": "attach-document-note-field", fullWidth: true, multiline: true, rows: MULTILINE_ROW_HEIGHT }))),
                    React.createElement(Grid, { item: true, xs: 12, sm: 12 },
                        React.createElement(FileInput, Object.assign({}, formPropsMultipleFileInput("file"), { id: "text-button-file", multiple: true })))))),
        React.createElement(DialogActions, null,
            React.createElement(Button, { onClick: () => triggerSubmit(), "data-test": "attach-document-upload-button", color: "primary" }, "Upload Document"))));
};
